import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from '../../../services/employee.service';
import { Employee } from '../../../models/employee.model';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { RestResponse } from '../../../models/restResponse.mode';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    DropdownModule,
    TooltipModule,
  ],
  selector: 'app-list-employee',
  templateUrl: './list-employee.component.html',
  styleUrls: ['./list-employee.component.css'],
})
export class ListEmployeeComponent implements OnInit {
  employees: Employee[] = [];
  searchTerm = '';
  loading = true;
  totalRecords = 0;
  first = 0;
  rows = 5;
  currentPage = 1;
  activeFilter: string = 'ativo';
  statusOptions = [
    { label: 'Todos', value: 'todos' },
    { label: 'Ativo', value: 'ativo' },
    { label: 'Inativo', value: 'inativo' },
  ];

  constructor(
    private employeeService: EmployeeService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.loadEmployees();
  }

  loadEmployees(): void {
    this.loading = true;
    let active: boolean | undefined = undefined;
    if (this.activeFilter === 'ativo') active = true;
    else if (this.activeFilter === 'inativo') active = false;

    this.employeeService.list(this.searchTerm, active, this.currentPage).subscribe({
      next: (response: RestResponse<Employee[]>) => {
        if (response.data && Array.isArray(response.data)) {
          this.employees = response.data;
          this.totalRecords = response.pagination?.totalRecords ?? this.employees.length;
        } else {
          this.employees = [];
          this.totalRecords = 0;
        }
        this.loading = false;
      },
      error: () => {
        this.employees = [];
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.first = 0;
    this.loadEmployees();
  }

  createEmployee(): void {
    this.router.navigate(['/app/employees/new']);
  }

  edit(employee: Employee): void {
    this.router.navigate(['/app/employees/edit', employee.id]);
  }

  delete(employee: Employee): void {
    if (confirm('Tem certeza que deseja excluir este funcionário?')) {
      this.employeeService.delete(employee.id).subscribe({
        next: () => this.loadEmployees(),
        error: () => alert('Erro ao excluir funcionário.'),
      });
    }
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.rows = event.rows ?? this.rows;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadEmployees();
  }
}
